import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CeProvidersModule } from './providers/providers.module';

import { LayoutModule } from 'layout/layout.module';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ChargeyeTranslateLoader } from './localization/translate-loader';
import { StationsServiceModule } from 'shared/stations-service/stations.module';
import { setupIcons } from 'icons';
import { APP_BASE_HREF, PlatformLocation, registerLocaleData } from '@angular/common';
import { LocaleModule } from 'shared/locale/locale.module';
import { LocationStatusComponent } from 'locations/location-dialog/status/location-status.component';
import { getCurrentLanguageFromPath } from 'shared/utils/getCurrentLanguageFromPath';
import localeFr from '@angular/common/locales/fr';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { LicenseRedirectPopupComponent } from './license-redirect-popup/license-redirect-popup.component';
import { DebugModeModule } from './shared/debug-mode/debug-mode.module';
import { SECTION_BUILDER_PROVIDERS } from './shared/ai-diagnostic-streaming/section-builders/builder-providers';

registerLocaleData(localeFr);

@NgModule({
    declarations: [AppComponent, CookieBannerComponent, LicenseRedirectPopupComponent],
    imports: [
        BrowserModule,
        StationsServiceModule,
        AppRoutingModule,
        HttpClientModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        LayoutModule,
        CeProvidersModule,
        BrowserAnimationsModule,
        LocaleModule,
        DebugModeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (http) => new ChargeyeTranslateLoader(http),
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        ...SECTION_BUILDER_PROVIDERS,
        {
            provide: APP_BASE_HREF,
            useFactory: (s: PlatformLocation) => baseUrlFactory(s.getBaseHrefFromDOM()),
            deps: [PlatformLocation],
        },
        {
            provide: LOCALE_ID,
            useFactory: () => getCurrentLanguageFromPath(),
        },
        Title,
        LocationStatusComponent,
        CookieBannerComponent,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        // set up SVG icons
        setupIcons(matIconRegistry, domSanitizer);
    }
}

export function baseUrlFactory(baseUrl: string) {
    // const currentLanguage = getCurrentLanguageFromPath();

    // trim last slash from baseUrl
    const trimmed = trimLastSlashFromUrl(baseUrl);

    // add language to baseUrl is not needed as localized build takes care of assigning baseHref to the correct language already. Check angular.json > project > chargeye > i18n
    // if (currentLanguage && currentLanguage !== 'en') {
    //     trimmed += `/${currentLanguage}`;
    // }

    return trimmed;
}

function trimLastSlashFromUrl(baseUrl: string) {
    if (!baseUrl?.trim()) {
        return '';
    } else if (baseUrl[baseUrl.length - 1] === '/') {
        const trimmedUrl = baseUrl.substring(0, baseUrl.length - 1);
        return trimmedUrl;
    } else {
        return baseUrl;
    }
}
